<template>
    <div class="home-view">
        <Topbar />
        <br>
        <br>
        <div class="container-img text-left ml-2 mr-2" style="margin-top: 10px; justify-content: center;">
            <!-- Content Row -->
            <div class="card shadow col-md-6 m-auto p-0">
                <div class="card-header pt-1 pb-1" :style="{ backgroundColor: moduloAtual().color }">
                    <h6 class="m-0 font-weight-bold text-white text-center">
                        <div>
                            Cubagem
                            <div v-show="carregando" class="spinner-grow">
                                <span class="sr-only">Loading...</span>
                            </div>
                        </div>
                    </h6>
                </div>
                <fieldset :disabled="carregando">
                    <div class="card-body bg-light text-primary-dark p-2">
                      <div>
                            <div class="text-center">
                                <div style="display: flex;">
                                    <div class="col p-0">
                                        <InputDefaultApp
                                            idInput="searchInput"
                                            inputPlaceHolderSufixo="Digite a produto aqui"
                                            titleScan="Escanear Produto"
                                            :enterKey="(e) => getProduto(e.target.value)"
                                            @displayScanFunction="getProduto"
                                            :errorMessage="this.errorMessage"
                                        >
                                        </InputDefaultApp>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="card small" v-if="this.produto">
                            <div class="card-body p-1 small">
                                <input 
                                    class="text-danger font-weight-bold form-control form-control-sm mb-1"
                                    readonly
                                    :value="produto.descricao ">

                                <span>SKU: </span>
                                <span class="text-danger font-weight-bold">
                                    {{ produto.sku }}
                                </span>
                                <br>
                                <span>Cliente: </span>
                                <span class="text-danger font-weight-bold">{{ produto.cliente.fantasia }}</span>
                            </div>
                        </div>
                        <div class="card small mt-2" v-if="this.produto">
                            <div class="card-body">
                                <div class="row">
                                    <div class="col-6">
                                        <label for="peso">Peso(g)</label>
                                        <input
                                            type="number"
                                            id="peso"
                                            class="form-control form-control-sm"
                                            :value="produto.pesobruto"
                                            onclick="document.getElementById('peso').select()"
                                            min="0">
                                    </div>
                                    <div class="col-6">
                                        <label for="comprimento">Comprimento(cm)</label>
                                        <input
                                            type="number"
                                            id="comprimento"
                                            class="form-control form-control-sm"
                                            :value="produto.comprimento"
                                            onclick="document.getElementById('comprimento').select()">
                                    </div>
                                </div>
                                <div class="row mt-2">
                                    <div class="col-6">
                                        <label for="largura">Largura(cm)</label>
                                        <input
                                            type="number"
                                            id="largura"
                                            class="form-control form-control-sm"
                                            :value="produto.largura"
                                            onclick="document.getElementById('largura').select()"
                                            >
                                    </div>
                                    <div class="col-6">
                                        <label for="altura">Altura(cm)</label>
                                        <input
                                            type="number"
                                            id="altura"
                                            class="form-control form-control-sm"
                                            :value="produto.altura"
                                            onclick="document.getElementById('altura').select()">
                                    </div>
                                </div>
                            </div>
                        </div>
                        <button class="btn btn-sm btn-block btn-primary mt-2" @click="salvarCubagem()" v-if="this.produto">
                            Salvar Cubagem
                            <em class="fa fa-save ml-2"></em>
                        </button>
                    </div>
                </fieldset>
            </div>
        </div>
        <div v-if="!this.produto" class="text-center text-secondary mt-5">
            <em class="mt-2 mb-3 fa fa-barcode fa-3x"></em>
            <h6>Bipe o código do produto!</h6>
        </div>
        <LogoutModal />
        <FooterBar />
        <Modal
            id="modalRetorno"
            title="Sucesso"
            :carregando="carregando"
            :buttonList="[]"
            :cancelFunction="() => closeModal('modalRetorno')"
            cancelText="OK"
        >
            <div class="small text-center">
                <em class="fa fa-check-circle text-success fa-3x"></em>
                <br>
                <br>
                <span>{{ this.retornoMessage }}</span>
            </div>
        </Modal>
        <Modal
            id="modalError"
            title="Aviso"
            :carregando="carregando"
            :buttonList="[]"
            :cancelFunction="() => closeModal('modalError')"
            cancelText="OK"
        >
            <div class="small text-center">
                <em class="fa fa-info-circle text-warning fa-3x"></em>
                <br>
                <br>
                <span>{{ this.errorMessageModal }}</span>
            </div>
        </Modal>
    </div>
</template>
  
  
<script>
    // @ is an alias to /src
    import Topbar from '@/components/Topbar.vue'
    import FooterBar from '@/components/FooterBar.vue'
    import LogoutModal from '@/components/LogoutModal.vue'
    import ViewMixin from './ViewMixin'
    import { DEFAULT_ERROR_MESSAGE, ServerErrorException, TokenInvalidoException } from '../services/exceptions'
    import api, { getUsername, getPerfil, getUserId } from '../services/api'
    import InputDefaultApp from "../components/InputDefaultApp.vue";
    import $ from "jquery";
    import Modal from "../components/Modal.vue";
    import audioService from '@/services/audioService.js';

    export default {
        name: 'Cubagem',
        mixins: [
            ViewMixin
        ],
        components: {
            Topbar,
            LogoutModal,
            FooterBar,
            InputDefaultApp,
            Modal,
        },
    
        data: () => {
            return {
                produto: null,
                errorMessage: null,
                retornoMessage: null,
                errorMessageModal: null,
            };
        },
    
        async mounted() {
            try {
                await this.validarToken();
                setTimeout(() => {
                    document.getElementById('searchInput').focus();
                }, 1000);
            } catch (e) {
                if (e instanceof TokenInvalidoException) {
                    this.handleTokenInvalidoException();
                } else if (e instanceof ServerErrorException) {
                    alert(e.message);
                } else {
                    alert(DEFAULT_ERROR_MESSAGE);
                }      
            }
        },
    
        methods: {
            getUsername,
            getPerfil,

            async validarToken() {
                this.carregando = true;
        
                await api.get("/validar-token");
        
                this.carregando = false;
            },

            showMessageSuccess(message) {
                this.retornoMessage = message;
                $("#modalRetorno").modal('show');
            },

            showErrorModal(message) {
                this.errorMessageModal = message;
                $("#modalError").modal('show');
            },

            playSound() {
                audioService.ops();
            },

            playSoundSuccess() {
                audioService.success();
            },

            closeModal(modalId) {
                $('#'+modalId).modal('hide');
                this.onModalClosed();

                if (modalId == "modalRetorno") {
                    $("#searchInput").val("");
                    $("#searchInput").focus();
                    this.produto = null;
                }
            },

            onModalClosed() {
                //
            },

            async getProduto(codbarras) {
                try {
                    let result = await api.post(`/inbound/produto`, {
                        codigoBarras: codbarras
                    });

                    if (result.data.produto) {
                        this.produto = result.data.produto;
                    }

                    setTimeout(() => {
                        document.getElementById('peso').focus();
                        document.getElementById('peso').select();
                    }, 250);
                } catch (error) {
                    this.errorMessage = error.data;
                    this.playSound();
                }
            },

            validar() {
                
                if ($("#peso").val() <= 0) {
                    this.showErrorModal("Peso não pode ser menor ou igual a zero!");
                    $("#peso").val("");
                    $("#peso").focus();
                    return false;
                }

                if ($("#comprimento").val() <= 0) {
                    this.showErrorModal("Comprimento não pode ser menor ou igual a zero!");
                    $("#comprimento").val("");
                    $("#comprimento").focus();
                    return false;
                }

                if ($("#largura").val() <= 0) {
                    this.showErrorModal("Largura não pode ser menor ou igual a zero!");
                    $("#largura").val("");
                    $("#largura").focus();
                    return false;
                }

                if ($("#altura").val() <= 0) {
                    this.showErrorModal("Altura não pode ser menor ou igual a zero!");
                    $("#altura").val("");
                    $("#altura").focus();
                    return false;
                }

                return true;
            },

            async salvarCubagem() {

                if (!this.validar()) {
                    this.playSound();
                    return;
                }

                try {
                    let result = await api.post(`/inbound/salvarcubagem`, {
                        peso: $("#peso").val(),
                        comprimento: $("#comprimento").val(),
                        largura: $("#largura").val(),
                        altura: $("#altura").val(),
                        idProduto: this.produto.idprodutos,
                        idUsuario: getUserId(),
                    });

                    if (result.data.updated) {
                        this.showMessageSuccess("Cubagem salva com sucesso!");
                        this.playSoundSuccess();
                    }
                } catch (error) {
                    this.errorMessage = error.data;
                }
            },
        }
    }
</script>
  
<style scoped lang="scss">    
    .home-view {
        height: 100%;
    }

    .container-img {
        height: auto;
        display: flex;
        justify-content: center;
        align-self: center;
    }
</style>
  